import { storage } from '@/firebase';

const uploadFile = async (file) => {
  try {
    const allowedTypes = ['application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
    if (!allowedTypes.includes(file.type)) throw new Error('Somente arquivos DOCX são permitidos.');

    const fileName = `${new Date().getTime()}_${file.name}`;
    const filePath = `contracts_template/${fileName}`;

    const storageRef = storage.ref(filePath);

    const uploadTask = storageRef.put(file);

    await new Promise((resolve, reject) => {
      uploadTask.on(
        'state_changed',
        function progress(snapshot) {
          const percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        function error(err) {
          reject(err);
        },
        function complete() {
          resolve();
        },
      );
    });
    return filePath;
  } catch (error) {
    console.error('Erro ao fazer upload do arquivo:', error.message);
    throw error;
  }
};
const downloadImg = async (path) => {
  try {
    const fileRef = storage.ref(path);
    const downloadURL = await fileRef.getDownloadURL();
    const response = await fetch(downloadURL);
    return await response.blob();
  } catch (error) {
    console.error(error);
  }
};
const deleteImg = async (path) => {
  try {
    await storage.ref(path).delete();
  } catch (err) {
    console.error(`Error - deleteImg ${err}`);
  }
};

export default {
  deleteImg,
  uploadFile,
  downloadImg,
};